import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Productsestore.css";
import { FaThLarge, FaThList, FaStar } from "react-icons/fa";

import paint1 from "../assets/paint1.png";
import paint2 from "../assets/paint2.png";
import paint3 from "../assets/paint3.png";
import paint4 from "../assets/paint4.png";
import paint5 from "../assets/paint5.png";
import paint6 from "../assets/paint6.png";
import paint7 from "../assets/paint7.png";
import paint8 from "../assets/paint8.png";

const allProducts = [
   {
    id: 8,
    name: "Glamur Acrylic",
    price: "Rs 175 - Rs 350",
    img: paint8,
    type: "Glamur Acrylic",
    reviewCount: 52,
    description:
      "Higher quality acrylic with excellent bonding for exterior applications.",
  },
  {
    id: 1,
    name: "Plastic Emulsion",
    price: "Rs 290 - Rs 4030",
    img: paint1,
    type: "Plastic Emulsion",
    reviewCount: 187,
    description:
      "Smooth matte finish paint ideal for interior walls and ceilings.",
  },
  {
    id: 2,
    name: "High Class Emulsion",
    price: "Coming Soon",
    img: paint6,
    type: "High Class Emulsion",
    reviewCount: 96,
    description:
      "Luxurious emulsion offering superior coverage and rich colors.",
  },
  {
    id: 3,
    name: "Wall Putty",
    price: "Rs 260 - Rs 3630",
    img: paint2,
    type: "Wall Putty",
    reviewCount: 243,
    description:
      "Smoothens rough walls and provides a strong base for paint application.",
  },
  {
    id: 4,
    name: "Gloss Enamel",
    price: "Rs 985 - Rs 3900",
    img: paint7,
    type: "Gloss Enamel",
    reviewCount: 121,
    description:
      "High-gloss, durable enamel perfect for metal and wood surfaces.",
  },
  {
    id: 5,
    name: "Aquatic Matt Emulsion",
    price: "Coming Soon",
    img: paint3,
    type: "Aquatic Matt Emulsion",
    reviewCount: 74,
    description:
      "Water-based emulsion with anti-fungal properties and smooth matt texture.",
  },
  {
    id: 6,
    name: "Weather Guard",
    price: "Coming Soon",
    img: paint4,
    type: "Weather Guard",
    reviewCount: 158,
    description:
      "Long-lasting exterior paint designed to resist rain, heat, and dust.",
  },
  {
    id: 7,
    name: "Aquatic Wall Sealer",
    price: "Rs 400 - Rs 5265",
    img: paint5,
    type: "Aquatic Wall Sealer",
    reviewCount: 209,
    description:
      "Premium primer that enhances paint adhesion and prevents dampness.",
  },
 
];

export default function Productsestore() {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState("All Products");
  const [viewMode, setViewMode] = useState("grid");
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState("best-selling");

  const filteredByType =
    selectedType === "All Products"
      ? allProducts
      : allProducts.filter((p) => p.type === selectedType);

  const filtered = filteredByType.filter((product) => {
    const query = searchTerm.trim().toLowerCase();
    if (!query) return true;

    return (
      product.name.toLowerCase().includes(query) ||
      product.description.toLowerCase().includes(query) ||
      product.type.toLowerCase().includes(query)
    );
  });

  const getSortPrice = (priceLabel) => {
    const values = String(priceLabel || "")
      .match(/\d+/g)
      ?.map(Number);
    if (!values || values.length === 0) return Number.POSITIVE_INFINITY;
    return Math.min(...values);
  };

  const visibleProducts = [...filtered].sort((a, b) => {
    if (sortBy === "price-low-high") {
      return getSortPrice(a.price) - getSortPrice(b.price);
    }
    if (sortBy === "price-high-low") {
      return getSortPrice(b.price) - getSortPrice(a.price);
    }
    return (b.reviewCount ?? 0) - (a.reviewCount ?? 0);
  });

  const categories = [
    "All Products",
    "Plastic Emulsion",
    "Aquatic Matt Emulsion",
    "Weather Guard",
    "Aquatic Wall Sealer",
    "High Class Emulsion",
    "Wall Putty",
    "Gloss Enamel",
    "Glamur Acrylic",
  ];

  return (
    <section className="productsestore">
      <h2 className="productsestore-title">
        Shop Premium Paint Products Online
      </h2>
      <p className="productsestore-desc">
        Welcome to Glamur Paints' official online store, where you can browse
        and purchase Pakistan's finest wall paints from the comfort of your
        home. Since 1984, we've been Pakistan's trusted paint partner, and now
        we bring our complete product range directly to you with convenient
        online ordering.
      </p>

      <div className="productsestore-layout">
        {/* Sidebar */}
        <div className="productsestore-sidebar">
          <h3>Products</h3>
          <div className="radio-group">
            {categories.map((cat) => (
              <label key={cat} className="custom-radio">
                <input
                  type="radio"
                  name="category"
                  checked={selectedType === cat}
                  onChange={() => setSelectedType(cat)}
                />
                <span className="radio-label">{cat}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Main Product Section */}
        <div className="productsestore-main">
          <div className="productsestore-controls">
            <input
              type="text"
              className="productsestore-search"
              placeholder="Search products..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <div className="productsestore-view">
              <FaThLarge
                className={viewMode === "grid" ? "active" : ""}
                onClick={() => setViewMode("grid")}
              />
              <FaThList
                className={viewMode === "list" ? "active" : ""}
                onClick={() => setViewMode("list")}
              />
            </div>
            <span className="productsestore-count">
              {visibleProducts.length} products
            </span>
            <select
              className="productsestore-sort"
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
            >
              <option value="best-selling">Best selling</option>
              <option value="price-low-high">Price: Low to High</option>
              <option value="price-high-low">Price: High to Low</option>
            </select>
          </div>

          {/* Product Cards */}
          <div className={`productsestore-grid ${viewMode}`}>
            {visibleProducts.length > 0 ? (
              visibleProducts.map((product) => (
                <div
                  key={product.id}
                  className="productsestore-card"
                  onClick={() => navigate(`/products/${product.id}`)}
                  style={{ cursor: "pointer" }}
                >
                  <img src={product.img} alt={product.name} />
                  <h4>{product.name}</h4>
                  <p>{product.description}</p>
                  <div className="productsestore-price">{product.price}</div>
                  <div className="productsestore-stars">
                    {[...Array(5)].map((_, i) => (
                      <FaStar key={i} className="star" />
                    ))}
                    <span>({product.reviewCount ?? 0})</span>
                  </div>
                  <button className="productsestore-buy">Select</button>
                </div>
              ))
            ) : (
              <div className="productsestore-empty">
                No products found for your current search/filter.
              </div>
            )}

            {/* Paint Calculator Box */}
            <div className="productsestore-calc">
              <div className="productsestore-calc-text">
                <h4>Get the exact paint you need — no guesswork.</h4>
                <button
                  className="productsestore-calc-btn"
                  onClick={() => navigate("/paint-calculator")}
                >
                  PAINT CALCULATOR
                </button>
              </div>
            </div>
          </div>

          <button
            className="productsestore-viewall"
            onClick={() => {
              setSelectedType("All Products");
              setSearchTerm("");
              setSortBy("best-selling");
            }}
          >
            View All Products
          </button>
        </div>
      </div>
    </section>
  );
}
